import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IRideSoftValidationErrorGeoProdMaxShiftGapProps } from "../models";

export const RideValidationSoftErrorGeoprodMaxShiftGap: FC<
  IRideSoftValidationErrorGeoProdMaxShiftGapProps
> = ({ validationErrors, errorType }) => {
  const { t } = useTranslation();
  const passengersNames = validationErrors
    .map(error => error.additional?.passengerInfo)
    .join(", ");

  return (
    <li>
      {t(`validation.softValidation.${errorType}`)} {passengersNames}
    </li>
  );
};
